// @flow
import * as React from 'react'
import styled from 'styled-components'
import Modal from 'ui/atoms/Modal'
import Text from 'ui/atoms/Text'

type Props = {
  title: string,
  message: string,
  confirmText: string,
  cancelText: string,
  showConfirm: boolean,
  onConfirm: () => void,
  onCancel: () => void,
}

const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

function ConfirmModal({
  title,
  message,
  confirmText,
  cancelText,
  showConfirm,
  onConfirm,
  onCancel,
}: Props): React.Node {
  return (
    <Modal
      primaryAction
      secondaryAction
      closeButton={true}
      dismissOnOutsideClick={true}
      onHide={() => {
        onCancel()
      }}
      onPrimaryAction={onConfirm}
      onSecondaryAction={onCancel}
      primaryActionText={confirmText}
      secondaryActionText={cancelText}
      show={showConfirm}
      size="small"
    >
      <ConfirmContainer>
        <Text $large>{title}</Text>
        <Text $small>{message}</Text>
      </ConfirmContainer>
    </Modal>
  )
}

export default ConfirmModal
